import { TablePagination, TablePaginationProps } from "@mui/material"

import './PaginationElement.scss'

// interface TablePaginationElementProps extends TablePaginationProps {

// }

export default function PaginationElement(props: TablePaginationProps) {
    const combineClassName = `${props?.className ?? ''} table-pagination-element `
    return (
        <TablePagination
            className={combineClassName}
            rowsPerPageOptions={[5, 10, 20, 50]}
            {...props}
        />
    )
}